import { color } from '../../../theme/Color';
import {
  formatValueWithMiddlewares,
  checkForNA,
  appendPercentage,
} from '../../utils/helper';

export default {
  type: 'Chart',
  handler: (response = [], mode = 'light') => {
    const axisColor = mode === 'light' ? '#616161' : '#efefef';
    const secondaryAxisColor = mode === 'light' ? '#616161' : '#d0d0d0';

    const xAxis = {
      data: response?.map((item) => item.marketName) ?? [],
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: axisColor,
        interval: 0,
        rotate: response?.length > 4 ? 45 : 0, // Rotate labels if too many items
      },
      axisLine: {
        color: axisColor,
      },
    };

    const yAxis = [
      {
        show: true,
        type: 'value',
        axisLabel: {
          color: axisColor,
          formatter: (value) =>
            formatValueWithMiddlewares(value, [checkForNA, appendPercentage]),
        },
        position: 'left',
        axisLine: {
          show: true,
          lineStyle: {
            color: secondaryAxisColor,
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'solid',
            color: mode === 'light' ? '#DFDFDF' : '#3a3a3a',
          },
        },
      },
    ];

    const grid = {
      top: '5%',
      bottom: '25%',
      left: '5%',
      right: '5%',
      containLabel: true,
    };

    const series = [
      {
        name: 'Adoption Rate By Persona',
        type: 'bar',
        barWidth: '15',
        itemStyle: {
          color: color._A35079,
          barBorderRadius: [10, 10, 0, 0],
        },
        data: response?.map((entry) => entry?.adoptionRate),
        label: {
          show: false,
        },
      },
    ];

    const tooltip = {
      show: true,
      position: ['30%', '10%'],
      axisPointer: {
        type: 'shadow',
      },
      valueFormatter: function (value) {
        return formatValueWithMiddlewares(value, [
          checkForNA,
          appendPercentage,
        ]);
      },
    };

    const legend = {
      show: true,
      icon: 'circle',
      bottom: '0%',
      left: 'center',
      textStyle: {
        color: mode === 'light' ? `${color._616161}` : `${color._d0d0d0}`,
        fontFamily: 'Inter',
        fontSize: '12px',
      },
    };

    return {
      tooltip,
      legend,
      xAxis,
      yAxis,
      series,
      grid,
    };
  },
};
